/**
 * Process use-cases — the data behind the Process "what are you mapping?"
 * picker. Declared as plain data so the set can be tuned / A-B'd without code
 * changes (the create surface is the top of the activation funnel). Each maps
 * to an existing Seed Registry id, so selecting one hydrates a real starting
 * diagram via the flowchart picker's existing onSelectStarter handler.
 */
import React from 'react'
import { ClipboardCheck, Workflow, GitBranch, Siren, Share2 } from 'lucide-react'
import type { UseCaseOption } from '../../../components/start-picker/UseCasePicker'

export interface ProcessUseCase extends UseCaseOption {
  /** Seed Registry id hydrated on select. */
  seedId: string
}

export const PROCESS_USE_CASES: ProcessUseCase[] = [
  {
    id: 'sop',
    name: 'Standard Operating Procedure',
    description: 'Step-by-step SOP with owner lanes',
    icon: React.createElement(ClipboardCheck, { className: 'size-4' }),
    seedId: 'new-hire-onboarding-sop',
  },
  {
    id: 'approval',
    name: 'Approval Workflow',
    description: 'Cross-team review & sign-off',
    icon: React.createElement(Workflow, { className: 'size-4' }),
    seedId: 'swimlane-approval',
  },
  {
    id: 'bpmn',
    name: 'Business Process (BPMN)',
    description: 'Events, tasks, gateways',
    icon: React.createElement(GitBranch, { className: 'size-4' }),
    seedId: 'bpmn-order',
  },
  {
    id: 'incident',
    name: 'Incident / Postmortem',
    description: 'Timeline, five whys, actions',
    icon: React.createElement(Siren, { className: 'size-4' }),
    seedId: 'incident-postmortem',
  },
  {
    id: 'flowchart',
    name: 'Simple Flowchart',
    description: 'Decisions & paths',
    icon: React.createElement(Share2, { className: 'size-4' }),
    seedId: 'flowchart-basic',
  },
]
